import type { SVGProps } from 'react'

export const LockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 14 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M3.14282 3.9375V5.25H4.85711V3.9375C4.85711 2.72891 5.81604 1.75 6.99996 1.75C8.18389 1.75 9.14282 2.72891 9.14282 3.9375V5.25H10.8571V3.9375C10.8571 1.76367 9.12943 0 6.99996 0C4.8705 0 3.14282 1.76367 3.14282 3.9375Z"
        fill="currentColor"
      />
      <path
        d="M2.71429 5.25C1.76875 5.25 1 6.03477 1 7V12.25C1 13.2152 1.76875 14 2.71429 14H11.2857C12.2312 14 13 13.2152 13 12.25V7C13 6.03477 12.2312 5.25 11.2857 5.25H2.71429ZM7.85714 8.75V10.5C7.85714 10.984 7.47411 11.375 7 11.375C6.52589 11.375 6.14286 10.984 6.14286 10.5V8.75C6.14286 8.26602 6.52589 7.875 7 7.875C7.47411 7.875 7.85714 8.26602 7.85714 8.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect fill="currentColor" height="14" transform="translate(1)" width="12" />
      </clipPath>
    </defs>
  </svg>
)
